// Copyright (c) 2021 Deere & Company

import * as fetchService from '../../../shared/services/fetch';
import { getBasePath } from '../../../shared/services/get-base-path';
import { handleError } from '../../../shared/services/error-handlers';

const basePath = getBasePath();

export async function getEnvironments ( ) {

    const endPoint = `${basePath}/reaping/inventory-environment`;

    const options = {
        method: 'GET'
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function getInventorySources ( ) {

    const endPoint = `${basePath}/reaping/reaping-inventory-source`;

    const options = {
        method: 'GET'
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function getTransactionSources ( ) {

    const endPoint = `${basePath}/reaping/reaping-transaction`;

    const options = {
        method: 'GET'
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function getSuppressSources ( ) {

    const endPoint = `${basePath}/reaping/reaping-surpress-call`;

    const options = {
        method: 'GET'
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function getATPSetup ( env, inv ) {

    const endPoint = `${basePath}/reaping/inventory-source`;
    const payLoad = {
        environment: env,
        inventorySource: inv
    };

    const options = {
        body: JSON.stringify( payLoad ),
        headers: {'Content-Type': 'application/json'},
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function saveATPSetup ( payload ) {

    const endPoint = `${basePath}/reaping/update-inventory`;

    const options = {
        body: JSON.stringify( payload ),
        headers: {'Content-Type': 'application/json'},
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response;

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}
